import { Link } from "react-router-dom"

export const DashboardCard = ({ order }) => {
    return (
      <div className="max-w-4xl m-auto p-2 mb-5 border dark:border-slate-700">
        <div className="flex justify-between text-sm m-2 font-bold dark:text-slate-200">
          <span>Order Id: {order.orderId ? order.orderId : "N/A"}</span>
          <span>Total: ${order.amountPaid ? order.amountPaid : 0}</span>
        </div>
        {order.cartList && order.cartList.length > 0 ? (
          order.cartList.map((product, index) => (
            <div key={index} className="flex flex-wrap justify-between max-w-4xl m-auto p-2 my-5 ">
              <div className="flex">
                <Link to={`/products/${product.id}`}>
                  <img
                    className="w-32 rounded"
                    src={product.poster ? product.poster : 'default_image_url'} 
                    alt={product.productName}
                  />
                </Link>
                <div className="">
                  <Link to={`/products/${product.id}`}>
                    <p className="text-lg ml-2 dark:text-slate-200">{product.productName}</p>
                  </Link>
                  <div className="text-lg m-2 dark:text-slate-200">
                    <span>${product.price}</span>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-lg ml-2 dark:text-slate-200">No products in this order</p>
        )}
      </div>
    )
}